// Jirasan NFT collection data
export const jirasanNfts = [
  {
    id: 7196,
    name: 'Jirasan #10000',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F5612.png',
    price: '0.85'
  },
  {
    id: 9262,
    name: 'Jirasan #9262',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F7391.png',
    price: '0.85'
  },
  {
    id: 3875,
    name: 'Jirasan #3875',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F2897.png',
    price: '0.85'
  },
  {
    id: 3939,
    name: 'Jirasan #3939',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F2938.png',
    price: '0.85'
  },
    
  {
    id: 9276,
    name: 'Jirasan #9276',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F7405.png',
    price: '0.85'
  },
  {
    id: 5821,
    name: 'Jirasan #5821',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F4454.png',
    price: '0.85'
  },
  {
    id: 3649,
    name: 'Jirasan #3649',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F2948.png',
    price: '0.85'
  },
  {
    id: 7145,
    name: 'Jirasan #7145',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F5561.png',
    price: '0.85'
  },
  {
    id: 9157,
    name: 'Jirasan #9157',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F7286.png',
    price: '0.85'
  },
  {
    id: 9279,
    name: 'Jirasan #9279',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F7408.png',
    price: '0.85'
  },
  {
    id: 6634,
    name: 'Jirasan #6634',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F5135.png',
    price: '0.85'
  },
  {
    id: 7015,
    name: 'Jirasan #7015',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F5469.png',
    price: '0.85'
  },
  {
    id: 113,
    name: 'Jirasan #113',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F113.png',
    price: '0.85'
  },
  {
    id: 1955,
    name: 'Jirasan #1955',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F1379.png',
    price: '0.85'
  },
  {
    id: 2226,
    name: 'Jirasan #2226',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F1583.png',
    price: '0.85'
  },
  {
    id: 3177,
    name: 'Jirasan #3177',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F2333.png',
    price: '0.85'
  },
  {
    id: 7527,
    name: 'Jirasan #7527',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F5896.png',
    price: '0.85'
  },
  {
    id: 7998,
    name: 'Jirasan #7998',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F6288.png',
    price: '0.85'
  },
  {
    id: 8420,
    name: 'Jirasan #8420',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F6665.png',
    price: '0.85'
  },
  {
    id: 7237,
    name: 'Jirasan #7237',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F5653.png',
    price: '0.85'
  },
  {
    id: 1815,
    name: 'Jirasan #1815',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F1267.png',
    price: '0.85'
  },
  {
    id: 9159,
    name: 'Jirasan #9159',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F7288.png',
    price: '0.85'
  },
  {
    id: 5633,
    name: 'Jirasan #5633',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F4307.png',
    price: '0.85'
  },
  {
    id: 48,
    name: 'Jirasan #48',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F48.png',
    price: '0.85'
  },
  {
    id: 7640,
    name: 'Jirasan #7640',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F5984.png',
    price: '0.85'
  },
  {
    id: 5310,
    name: 'Jirasan #5310',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F4045.png',
    price: '0.85'
  },
  {
    id: 5817,
    name: 'Jirasan #5817',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F4450.png',
    price: '0.85'
  },
  {
    id: 1780,
    name: 'Jirasan #1780',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F1240.png',
    price: '0.85'
  },
  {
    id: 168,
    name: 'Jirasan #168',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F168.png',
    price: '0.85'
  },
  {
    id: 4734,
    name: 'Jirasan #4734',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F3575.png',
    price: '0.85'
  },
  {
    id: 1432,
    name: 'Jirasan #1432',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F962.png',
    price: '0.85'
  },
  {
    id: 1939,
    name: 'Jirasan #1939',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F1366.png',
    price: '0.85'
  },
  {
    id: 5757,
    name: 'Jirasan #5757',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F4404.png',
    price: '0.85'
  },
  {
    id: 7018,
    name: 'Jirasan #7018',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F5472.png',
    price: '0.85'
  },
  {
    id: 6192,
    name: 'Jirasan #6192',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F4749.png',
    price: '0.85'
  },
  {
    id: 3274,
    name: 'Jirasan #3274',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F2411.png',
    price: '0.85'
  },
  {
    id: 4772,
    name: 'Jirasan #4772',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F3606.png',
    price: '0.85'
  },
  {
    id: 5112,
    name: 'Jirasan #5112',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F3884.png',
    price: '0.85'
  },
  {
    id: 9240,
    name: 'Jirasan #9240',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F7369.png',
    price: '0.85'
  },
  {
    id: 1333,
    name: 'Jirasan #1333',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F877.png',
    price: '0.85'
  },
  {
    id: 5232,
    name: 'Jirasan #5232',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F4055.png',
    price: '0.85'
  },
  {
    id: 165,
    name: 'Jirasan #165',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F164.png',
    price: '0.85'
  },
  {
    id: 3281,
    name: 'Jirasan #3281',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2F3UP35l03Au%252FTp0ADu%252BlTG1XbRyn%252BsYZB%252F5vpwLPkYPFDjCHxmzAvpyhJrYfnuYvj4Xv%252BAzu8onZHd3wXd94FyAHKIgikxI9qtb1hY0koZMM%253D.png',
    price: '0.85'
  },
  {
    id: 8006,
    name: 'Jirasan #8006',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F6296.png',
    price: '0.85'
  },
  {
    id: 9206,
    name: 'Jirasan #9206',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F7335.png',
    price: '0.85'
  },
  {
    id: 95,
    name: 'Jirasan #95',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F95.png',
    price: '0.85'
  },
  {
    id: 8065,
    name: 'Jirasan #8065',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F6348.png',
    price: '0.85'
  },
  {
    id: 6224,
    name: 'Jirasan #6224',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F4776.png',
    price: '0.85'
  },
  {
    id: 7836,
    name: 'Jirasan #7836',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F6155.png',
    price: '0.85'
  },
  {
    id: 7900,
    name: 'Jirasan #7900',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F6211.png',
    price: '0.85'
  },
  {
    id: 7963,
    name: 'Jirasan #7963',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F6262.png',
    price: '0.85'
  },
  {
    id: 7964,
    name: 'Jirasan #7964',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F6263.png',
    price: '0.85'
  },
  {
    id: 1718,
    name: 'Jirasan #1718',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F1189.png',
    price: '0.85'
  },
  {
    id: 7962,
    name: 'Jirasan #7962',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F6261.png',
    price: '0.85'
  },
  {
    id: 7958,
    name: 'Jirasan #7958',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F6257.png',
    price: '0.85'
  },
  {
    id: 5254,
    name: 'Jirasan #5254',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F4000.png',
    price: '0.85'
  },
  {
    id: 7965,
    name: 'Jirasan #7965',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F6264.png',
    price: '0.85'
  },
  {
    id: 8799,
    name: 'Jirasan #8799',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F6969.png',
    price: '0.85'
  },
  {
    id: 9260,
    name: 'Jirasan #9260',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F7389.png',
    price: '0.85'
  },
  {
    id: 7224,
    name: 'Jirasan #7224',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F5640.png',
    price: '0.85'
  },
  {
    id: 7961,
    name: 'Jirasan #7961',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F6260.png',
    price: '0.85'
  },
  {
    id: 1237,
    name: 'Jirasan #1237',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F801.png',
    price: '0.85'
  },
  {
    id: 4304,
    name: 'Jirasan #4304',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F3222.png',
    price: '0.85'
  },
  {
    id: 5320,
    name: 'Jirasan #5320',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F4052.png',
    price: '0.85'
  },
  {
    id: 1151,
    name: 'Jirasan #1151',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F730.png',
    price: '0.85'
  },
  {
    id: 6281,
    name: 'Jirasan #6281',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FUncommon%2F902.png',
    price: '0.85'
  },
  {
    id: 1582,
    name: 'Jirasan #1582',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F1078.png',
    price: '0.85'
  },
  {
    id: 4403,
    name: 'Jirasan #4403',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FUncommon%2F618.png',
    price: '0.85'
  },
  {
    id: 848,
    name: 'Jirasan #848',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FUncommon%2F12.png',
    price: '0.85'
  },
  {
    id: 2028,
    name: 'Jirasan #2028',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F1438.png',
    price: '0.85'
  },
  {
    id: 2246,
    name: 'Jirasan #2246',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F1589.png',
    price: '0.85'
  },
  {
    id: 4216,
    name: 'Jirasan #4216',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F3163.png',
    price: '0.85'
  },
  {
    id: 5409,
    name: 'Jirasan #5409',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F4123.png',
    price: '0.85'
  },
  {
    id: 1004,
    name: 'Jirasan #1004',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FUncommon%2F51.png',
    price: '0.85'
  },
  {
    id: 4185,
    name: 'Jirasan #4185',
    image: 'https://img-cdn.magiceden.dev/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fjirasanmeta.s3.eu-north-1.amazonaws.com%2FCommon%2F3133.png',
    price: '0.85'
  }
];
